import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import '../../../assets/style/SinglePage.css';

const BASE_URL =
    'https://mis.drtrefi.edu.ph/public/images/articles/';

// Convert API text safely
const formatText = (str) => {
    if (!str) return '';
    return str
        .replace(/&nbsp;/g, ' ')
        .replace(/\n/g, '<br />');
};

// Fix image URL (handles encoded + unicode filenames safely)
const buildImageUrl = (image) => {
    if (!image) return null;

    try {
        return `${BASE_URL}${encodeURIComponent(image)}`;
    } catch (e) {
        return `${BASE_URL}${image}`;
    }
};

function SinglePage() {
    const { short_title } = useParams();
    const [article, setArticle] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchArticle = async () => {
            try {
                const res = await axios.get(
                    `https://mis.drtrefi.edu.ph/api/articles/${short_title}?display_site=rtr`
                );

                const { results } = res.data;

                if (!results) {
                    setError('Failed to fetch journal details. Please try again later.');
                    return;
                }

                setArticle(results);
                setError(null);
            } catch (err) {
                console.error('API Error:', err);
                setError('Failed to fetch journal details. Please try again later.');
                setArticle(null);
            }
        };

        fetchArticle();
    }, [short_title]);

    if (error) return <h1 className="error-message">{error}</h1>;
    if (!article) return <h1 className="loading-message">Loading...</h1>;

    const {
        author = 'Unknown Author',
        body = 'Content is not available at the moment.',
        cover_image,
        title = 'Untitled',
        tags = 'No tags available',
        created_at,
    } = article;

    const imageUrl = buildImageUrl(cover_image);

    const formattedArticleContent = formatText(body);

    const formattedDate = created_at
        ? new Intl.DateTimeFormat('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
          }).format(new Date(created_at))
        : 'Unknown date';

    return (
        <main>
            <div className="container">
                <section className="mainContent details">
                    <h1><b>{title}</b></h1>

                    <div className="date">
                        <span>
                            Published On: <b>{formattedDate}</b>
                        </span>
                    </div>

                    {imageUrl ? (
                        <img
                            src={imageUrl}
                            className="main-img"
                            alt="Cover"
                            onError={(e) => {
                                e.target.src = '/placeholder-image.jpg';
                            }}
                        />
                    ) : (
                        <div className="img-placeholder">
                            Image not available
                        </div>
                    )}

                    <div
                        className="contentSection"
                        dangerouslySetInnerHTML={{ __html: formattedArticleContent }}
                    />

                    <div className="author" style={{ marginTop: '20px' }}>
                        <b>Written By: {author}</b>
                    </div>

                    <b className="tags">Tags: {tags}</b>
                </section>
            </div>
        </main>
    );
}

export default SinglePage;